import {BoxStyled, TypographyStyled} from './InfoLoading';

export const InfoNoData = () => {
  return (
    <BoxStyled>
      <TypographyStyled>There is no data available.</TypographyStyled>
    </BoxStyled>
  );
};
